module.exports = __webpack_public_path__ + "luckycatresort-build/img/checkout-fail.f96124e7.svg";